import React, { useState } from "react";
import VideoList from "../../components/Dashboard/Videos/VideoList";
import VideoModal from "../../components/Dashboard/Videos/VideoModal";
import Navbar from "../../components/Navbar";

export default function Videos() {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal(!showModal);

  return (
    <>
      <Navbar />

      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <div className="px-3 py-20 bg-opacity-10">
            <div className="w-full flex">
              <button className="btn ml-auto" onClick={toggleModal}>
                Add Video
              </button>
            </div>
            <VideoList />
          </div>
          {showModal && (
            <div className="modal-container">
              <VideoModal open={showModal} control={toggleModal} task="Add" />
            </div>
          )}
        </div>
      </section>
    </>
  );
}
